import React from 'react';

const PRESET_LOGOS = {
  1: { bg: '#1F3864', content: null },
  2: { bg: '#1F3864', content: <path d="M12 20h16M20 12v16" stroke="white" strokeWidth="2"/> },
  3: { bg: '#2563EB', content: <path d="M10 28L20 12L30 28Z" fill="white"/> },
  4: { bg: '#059669', content: <circle cx="20" cy="20" r="10" fill="white"/> },
  5: { bg: '#DC2626', content: <path d="M10 15h20v10H10z" fill="white"/> },
  6: { bg: '#7C3AED', content: <path d="M10 10L30 30M30 10L10 30" stroke="white" strokeWidth="2.5"/> },
};

export default function CompanyLogo({ company, size = 36, className = '' }) {
  if (!company) return null;

  const s = size;

  // Custom uploaded logo
  if (company.customLogo) {
    return (
      <img
        src={company.customLogo}
        alt={company.name}
        className={`rounded-lg object-contain bg-white ${className}`}
        style={{ width: s, height: s }}
        data-testid="company-logo"
      />
    );
  }

  // Preset SVG logo
  const preset = PRESET_LOGOS[company.logo] || PRESET_LOGOS[1];
  return (
    <svg
      width={s}
      height={s}
      viewBox="0 0 40 40"
      className={`rounded-lg flex-shrink-0 ${className}`}
      data-testid="company-logo"
    >
      <rect width="40" height="40" rx="8" fill={preset.bg} />
      {preset.content}
    </svg>
  );
}
